import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ruta-no-existe',
  templateUrl: './ruta-no-existe.component.html',
  styleUrls: ['./ruta-no-existe.component.css']
})
export class RutaNoExisteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
